export default __webpack_public_path__ + "static/media/AMIT_ MEHTA_Resume.4361884b.pdf";